<template lang="pug">
.leftNav
  el-input(v-model="filterTextSys", size="small", placeholder="输入关键字进行过滤", clearable)
  el-tree.treeList.filter-tree(
    ref="systree",
    node-key="nodeId",
    :data="sysData",
    :props="defaultRoleProps",
    :filter-node-method="filterNode",
    show-checkbox,
    @check="checkNodeChange",
    v-slot="{ node, data }"
  )
    node-icon(type="SystemRole") {{ data.roleName }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "./NodeIcon.vue";

export default {
  components: { NodeIcon },
  props: {
    // 选中的人员组件
    userList: { type: Array, default: () => [] }
  },
  data() {
    return {
      sysData: [], // 系统角色列表
      filterTextSys: "",
      defaultRoleProps: {
        children: "children",
        label: "roleName"
      },
      nowSelect: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ nodeId }) => nodeId) || [];
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.systree.filter(val);
    },
    userList: {
      immediate: true,
      async handler(val) {
        this.nowSelect = val;
        this.$refs.systree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    }
  },
  mounted() {
    this.getSysList();
  },
  methods: {
    // 获取系统角色列表
    async getSysList() {
      const res = await flowService.querySysRoleList(this.enterpriseId);
      this.sysData = res.data.map(e => { return { ...e, nodeId: e.roleID }; }) || [];
      if (this.nowSelect && this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.systree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    },
    // 系统角色树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.nowSelect = this.$refs.systree.getCheckedNodes();
      this.emitList();
    },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          ...e,
          id: e.roleID,
          userId: e.roleID,
          name: e.roleName,
          selectName: e.roleName,
          type: 1
        };
      });
      this.$emit("updateRight", "SystemRole", list);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    }
  }
};
</script>

<style>
</style>
